import {ArticlesPageMeta} from './container-options/articles.container'
import {BrandsProductListMeta} from './container-options/brands.container'
import {CatalogMeta} from './container-options/catalog.container'
import {FuncTestingPageTitle} from './container-options/func-testing.container'
import {NewsPageMeta} from './container-options/news.container'
import {VideoReviewsMeta} from './container-options/video.container'
import {PageFunctionsRegistry} from './registry'
import {articlesTransform} from './transforms/articles.transform'
import {brandsTransform} from './transforms/brands.transform'
import {catalogTransform} from './transforms/catalog.transform'
import {newsTransform} from './transforms/news.transform'
import {videoTransform} from './transforms/video.transform'
import {cartTransform} from './transforms/cart.transform'

import {funcTestingTransform} from './transforms/func-testing.transform'
import {shoeTestingTransform} from './transforms/shoe-testing.transform'
import {ProfilePageTitle} from '@/src/(pages)/profile/ui/page-title'

export function registerPageTransforms(registry: PageFunctionsRegistry) {
  registry.register('catalog', catalogTransform, 'transform')
  registry.register('catalog', CatalogMeta, 'pageTitle')

  registry.register('certificates', CatalogMeta, 'pageTitle')

  registry.register('articles', articlesTransform, 'transform')
  registry.register('articles', ArticlesPageMeta, 'pageTitle')

  registry.register('news', newsTransform, 'transform')
  registry.register('news', NewsPageMeta, 'pageTitle')

  registry.register('video', videoTransform, 'transform')
  registry.register('video', VideoReviewsMeta, 'pageTitle')

  registry.register('brands', brandsTransform, 'transform')
  registry.register('brands', BrandsProductListMeta, 'pageTitle')

  registry.register('func-testing', funcTestingTransform, 'transform')
  registry.register('func-testing', FuncTestingPageTitle, 'pageTitle')

  registry.register('shoe-testing', shoeTestingTransform, 'transform')
  registry.register('shoe-testing', FuncTestingPageTitle, 'pageTitle')

  registry.register('cart', cartTransform, 'transform')

  registry.register('profile', ProfilePageTitle, 'pageTitle')
  registry.register('profile-favourite', ProfilePageTitle, 'pageTitle')
}
